$(document).ready(function () {
  $('.js-contact-form').on("ajax:success", function(event, data, status, xhr){
    $(this).trigger("reset");
    if($(this).data().hideOnSuccess) {
      $(this).hide();
    }
    $('.js-contact-form-thanks').show();
    $('.js-contact-form-error').hide();
  }).on("ajax:error", function(event, xhr, status, error){
    if($(this).data().recaptchaActive) {
      grecaptcha.reset();
    }
    response = JSON.parse(xhr.responseText);
    $('.js-contact-form-error').text(response.errors[0]);
    $('.js-contact-form-error').show();
  });

  $('.js-contact-form-back').click(function(){
    $('.js-contact-form-thanks').hide();
    $('.js-contact-form').show();
  });
});
